import jexl from 'jexl';

import { size } from '../functions/size';
import { anyMatch } from './functions/anyMatch';
import { map } from './functions/map';

export const registerCustomFunctions = () => {
  jexl.addFunction('size', size);
  jexl.addFunction('anyMatch', anyMatch);
  jexl.addFunction('map', map);
};
